import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { InlineImageComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { ContactTypes } from '@digital-platform/rs-frontend/domain';

@Component({
  selector: 'digital-platform-facility-contact-us',
  standalone: true,
  imports: [CommonModule, InlineImageComponent, RouterModule],
  templateUrl: './facility-contact-us.component.html',
})
export class FacilityContactUsComponent {
  public readonly ContactTypes = ContactTypes;
}
